import { Configuration, LogLevel, PublicClientApplication } from '@azure/msal-browser';

// API scope for backend authentication
const apiScope = import.meta.env.VITE_API_SCOPE || 'api://aixa-share-api/Files.ReadWrite';

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID || 'common'}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};

// Request scopes for login - includes API scope
export const loginRequest = {
  scopes: ['openid', 'profile', 'email', apiScope],
};

// Request scopes for API token acquisition
export const tokenRequest = {
  scopes: [apiScope],
};

export const msalInstance = new PublicClientApplication(msalConfig);
